import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { BACKEND_URL } from '../../constants';
import { getAccessToken } from '../../service/auth';
import { IUserProfile } from './users';
import { userParamsToFormData } from '../helpers';

export const ownerApi = createApi({
  reducerPath: 'ownerApi',
  tagTypes: [],
  baseQuery: fetchBaseQuery({
    baseUrl: `${BACKEND_URL}/api/v1/owner`,
    prepareHeaders: async (headers) => {
      const accessToken = await getAccessToken();
      headers.set('authorization', `Bearer ${accessToken}`);
      return headers;
    },
  }),
  endpoints: (builder) => ({
    updateUserByOwner: builder.mutation<void, { user_id: string; data: Partial<IUserProfile> }>({
      query: ({ user_id, data }) => {
        return {
          url: `${BACKEND_URL}/api/v1/users/${user_id}`,
          method: 'PUT',
          body: userParamsToFormData(data),
        };
      },
    }),

    deleteUsers: builder.mutation<
      { errors: string[] },
      { apps_ids?: string[] | null; delete_apps_with_user?: boolean; checked_ids: number[] }
    >({
      query: (body) => ({
        method: 'DELETE',
        url: `${BACKEND_URL}/api/v1/users/${body.checked_ids ? body.checked_ids[0] : 0}`,
      }),
    }),

    createUser: builder.mutation<{ id: string }, Partial<IUserProfile>>({
      query: (body) => ({
        method: 'POST',
        body: userParamsToFormData(body),
        url: `${BACKEND_URL}/api/v1/users`,
      }),
    }),

    changePasswordByOwner: builder.mutation<
      void,
      {
        newPassword: string;
        userId: string;
      }
    >({
      query: ({ newPassword, userId }) => {
        return {
          url: `${BACKEND_URL}/api/v1/users/${userId}/password`,
          method: 'PUT',
          body: 'password=' + newPassword,
          headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' },
        };
      },
    }),
  }),
});

export const {
  useUpdateUserByOwnerMutation,
  useDeleteUsersMutation,
  useChangePasswordByOwnerMutation,
  useCreateUserMutation,
} = ownerApi;
